import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue } from '../colors';
import { GetThemeOptions } from '../../theme';
import { chronoDefinedDarkTokens, chronoDefinedLightTokens } from '@/theme/unityTokens';

export const secondaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? chronoDefinedLightTokens : chronoDefinedDarkTokens;
    return {
      main: tokens['--secondary-color-main'],
      highContrast: tokens['--secondary-color-high-contrast'],
      lowContrast: tokens['--secondary-color-low-contrast'],
    };
  }
  return mode === 'light'
    ? {
        main: blue[600],
        highContrast: blue[800],
        lowContrast: blue[150],
      }
    : {
        main: blue[500],
        highContrast: blue[300],
        lowContrast: blue[700],
      };
};
